import type { Router } from 'vue-router'

export default (router: Router) => {
  router.addRoute({
    path: '/forgot-password',
    name: 'ForgotPasswordPage',
    component: () => import('@/modules/forgotPassword/views/ForgotPasswordPage.vue'),
    meta: {
      layout: 'LoginSplitLayout',
      requiresAuth: false,
    },
  })
  router.addRoute({
    path: '/reset-password/:token',
    name: 'ResetPasswordPage',
    component: () => import('@/modules/forgotPassword/views/ResetPasswordPage.vue'),
    meta: {
      layout: 'LoginSplitLayout',
      requiresAuth: false,
    },
  })
  router.addRoute({
    path: '/reset-password',
    redirect: '/login',
  })
}
